/**
 * Format category names to sentence case in category listing pages
 * Similar to formatCategoryNames in megamenu.js
 */

document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    /**
     * Convert text to sentence case (first letter uppercase, rest lowercase)
     * Only applies if text is all uppercase
     */
    function toSentenceCase(text) {
        if (!text || typeof text !== 'string') return text;
        // Check if text is all uppercase (ignoring spaces and special chars)
        const hasUppercase = /[A-Z]/.test(text);
        const hasLowercase = /[a-z]/.test(text);
        // Only transform if text is all uppercase or mostly uppercase
        if (hasUppercase && !hasLowercase) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return text;
    }

    /**
     * Format category names in category listing pages
     */
    function formatCategoryNames() {
        // Format category names in category-miniature-inside-content
        document.querySelectorAll('.category-miniature-inside-content h3 a, .category-miniature-inside-content .h2 a').forEach(element => {
            const originalText = element.textContent.trim();
            const formattedText = toSentenceCase(originalText);
            if (formattedText !== originalText) {
                element.textContent = formattedText;
            }
        });

        // Format category names in custom-mega-submenu-card
        document.querySelectorAll('.custom-mega-submenu-card .custom-mega-menu-title').forEach(element => {
            const originalText = element.textContent.trim();
            const formattedText = toSentenceCase(originalText);
            if (formattedText !== originalText) {
                element.textContent = formattedText;
            }
        });
    }

    // Format on page load
    formatCategoryNames();

    // Also format when content is dynamically loaded
    const observer = new MutationObserver(() => {
        formatCategoryNames();
    });

    // Observe changes to the category listing container
    const categoryContainer = document.querySelector('.subcategories, .custom-mega-submenu-slider');
    if (categoryContainer) {
        observer.observe(categoryContainer, {
            childList: true,
            subtree: true
        });
    }
});
